"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setGameVars = setGameVars;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var actionSetGameVars = function actionSetGameVars(gameVars) {
  return {
    payload: gameVars,
    type: 'SET_GAME_VARS'
  };
};

function setGameVars(gameVars) {
  return function (dispatch) {
    var mapList = gameVars.mapList,
        rest = _objectWithoutProperties(gameVars, ["mapList"]);

    var zoneList = Object.values(mapList).reduce(function (result, map) {
      return _objectSpread({}, result, map.zoneList);
    }, {});
    dispatch(actionSetGameVars(_objectSpread({}, rest, {
      mapList: mapList,
      zoneList: zoneList
    })));
    return {
      mapList: mapList,
      zoneList: zoneList
    };
  };
}